import { yupResolver } from "@hookform/resolvers/yup";
import { message } from "antd";
import moment from "moment";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom';

import { validateCreateBanners, validateUpdateBanners } from "../../../helpers";
import { bannersChangeModalState, createBanner, refreshTableBanners, selectBannersForUpdate, selectBannersRefreshTable, selectIsUpdateBanners, setIsBannersForUpdate, updateBanner } from "../../../redux";
import { DataBanner } from "../../../redux/@types";
import useAppDispatch from "../../../redux/hooks/useAppDispatch";
import { TableProperties } from "../../../shared/components/ui/Table/types";
import { isPageHeroType } from "../banner-types";


export const useBanners = () => {
  const navigate = useNavigate();
    const dispatch = useAppDispatch();

    const isUpdateBanner = useSelector(
        selectIsUpdateBanners
      );
      const dataUpdateBanner = useSelector(
        selectBannersForUpdate
      );
      const isRefreshTableBanners = useSelector(
        selectBannersRefreshTable
      );

      const [isLoading, setIsLoading] = useState(false);
      const [tableProps, setTableProps] = useState<TableProperties>();


      const changeModalBannersState = () => {
        dispatch(setIsBannersForUpdate(false));
        dispatch(bannersChangeModalState());
      };

      const changeNavToBannersProducts = (id: number) => {
        navigate(`/bannersProducts/${id}`);
      };

      const formMethodsCreate = useForm<DataBanner>({
        resolver: yupResolver(validateCreateBanners),
      });

      const formMethodsUpdate = useForm<DataBanner>({
        resolver: yupResolver(validateUpdateBanners),
      });

      useEffect(() => {
        if (isUpdateBanner) {
          formMethodsCreate.reset();
          formMethodsUpdate.reset({ ...dataUpdateBanner,
            start_date: moment(dataUpdateBanner?.start_date).add(5, 'hours').format(),
            end_date: moment(dataUpdateBanner?.end_date).add(5, 'hours').format(), });
        }

        return () => {
          formMethodsUpdate.reset();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [isUpdateBanner, dataUpdateBanner]);

      const updateStatus = async(value: "active" | "inactive", id: any) =>{
        if (isLoading) return;
        setIsLoading(true);
        await updateBanner({
          id,
          status: value,
        })
        .then((res: Partial<DataBanner>) => {
          setIsLoading(false);
          if (res.id) {
            // dispatch(bannersChangeModalState());
            message.success(
              `Se ha actualizado con éxito el estado del banner con id:${res.id}`
            );
            dispatch(refreshTableBanners(true));
          } else {
            message.error(res as string);
          }
        })
        .catch((err: any) => {
          setIsLoading(false);
          console.log(err);
          message.error(err.message);
        });
      }

    const onSubmitCreateOrUpdate = async (data: DataBanner) => {
        //console.log({ data });
        if (isLoading) return;
        setIsLoading(true);
        const payload: Partial<DataBanner> = {
          ...data,
          start_date: moment(data.start_date).format(),
          end_date: moment(data.end_date).format(),
        };
        if (data.action_type === "URL" || isPageHeroType(data.type)) {
          payload.action_id = null;
        } else if (payload.action_id === undefined || payload.action_id === "") {
          payload.action_id = null;
        }
        if (isUpdateBanner) {
          console.log("Actualiando===>", payload);
          await updateBanner({
            ...payload,
          })
            .then((res: Partial<DataBanner>) => {
              setIsLoading(false);
              if (res.id) {
                // dispatch(bannersChangeModalState());
                message.success(
                  `Se ha actualizado con éxito el banner con id:${res.id}`
                );
                dispatch(refreshTableBanners(true));
              } else {
                message.error(res as string);
              }
            })
            .catch((err: any) => {
              setIsLoading(false);
              console.log(err);
              message.error(err.message);
            });
        } else {
          // console.log('Creando===>',data)
          await createBanner({
            ...payload,
          })
            .then((res: DataBanner) => {
              setIsLoading(false);
              if (res.id) {
                dispatch(bannersChangeModalState());
                message.success(
                  `Se ha creado con éxito el banner con id:${res.id}`
                );
                dispatch(refreshTableBanners(true));
              } else {
                message.error(res as any);
              }
            })
            .catch((err: any) => {
              setIsLoading(false);
              console.log(err);
              message.error(err.message);
            });
        }
      };

      useEffect(() => {
        if (isRefreshTableBanners) {
          tableProps?.refresh();
          dispatch(refreshTableBanners(false));
        }
      // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [isRefreshTableBanners]);
  return {
    //state
    isUpdateBanner,
    isLoading,
    tableProps,
    //methods
    formMethodsCreate,
    formMethodsUpdate,
    setTableProps,
    //functions
    changeModalBannersState,
    onSubmitCreateOrUpdate,
    changeNavToBannersProducts,
    updateStatus,
  }
}
